import React from 'react';
import FormField from '../../../components/forms/FormField';

export default function ObservacoesDiagnostico() {
  return (
    <div>
    <div className="mb-6 p-4 bg-blue-50 rounded-lg">
      <p className="text-sm text-blue-700">Esta seção permite registrar observações gerais e um diagnóstico preliminar sobre o desenvolvimento produtivo local.</p>
    </div>

    <div className="mt-4">
      <FormField
        name="pontos_fortes"
        label="Principais pontos fortes no desenvolvimento produtivo local"
        type="textarea"
        placeholder="Descreva os principais pontos fortes"
        helpText="Identifique os aspectos positivos e potencialidades do município"
      />
    </div>
    
    <div className="mt-4">
      <FormField
        name="desafios_identificados"
        label="Principais desafios identificados"
        type="textarea"
        placeholder="Descreva os principais desafios"
        helpText="Identifique os principais obstáculos ao desenvolvimento produtivo local"
      />
    </div>
    
    <div className="mt-4">
      <FormField
        name="sugestoes_politicas"
        label="Sugestões de políticas públicas"
        type="textarea"
        placeholder="Descreva sugestões de políticas públicas"
        helpText="Proponha políticas públicas que poderiam contribuir para o desenvolvimento produtivo local"
      />
    </div>
    <hr className="border-t border-gray-300 my-6" />
    <div className="mt-6 space-y-4">
      <FormField
        name="fontes_principais_secao8"
        label="Fontes principais"
        type="textarea"
        placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
        helpText=""
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
      
      <FormField
        name="links_acesso_secao8"
        label="Links de acesso"
        type="textarea"
        placeholder="Insira os links para acesso às fontes"
        helpText="Informe URLs para acesso às fontes quando disponível"
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
    </div>
  </div>
  );
}
